import { useEffect, useState, useContext } from 'react';
import { LoaderType, NextgenImage } from '@nextgen-web-framework/all';
import { isValidHttpUrl } from '../../../common/Utils';
import CMSImageContext from '../../../common/CMSImageContext';
import styles from './ImageWrapper.module.scss';
import { ImageProps, CmsImage } from './types/propsTypes';
export const ImageWrapper = (props: ImageProps) => {
  const { img, alt } = props;
  const [imgSrc, setImgSrc] = useState<string>(img ?? 'credit-card'); //fallback credit-card icon
  const imageList = useContext(CMSImageContext);
  useEffect(() => {
    isValidHttpUrl(img)
      ? setImgSrc(img)
      : imageList?.methods?.forEach((m: CmsImage) => m.display_title === img?.toLowerCase() && setImgSrc(m.image.url));
  }, [img, imageList]);

  return (
    <div className={`${styles['icon']}`}>
      {isValidHttpUrl(imgSrc) && (
        <NextgenImage
          loaderType={isValidHttpUrl(img) ? undefined : LoaderType.CONTENTSTACK}
          src={imgSrc}
          alt={alt}
          layout="fill"
        />
      )}
    </div>
  );
};
